module.exports = __webpack_public_path__ + "static/media/league-gothic.9900a464.eot";